export default __webpack_public_path__ + "static/gallery12-31649ab7bf2512186da1ee246bb92611.png";